'use client';

import PageType from '@alltrails/amplitude/enums/PageType';
import logShowMoreClicked from '@alltrails/amplitude/events/logShowMoreClicked';
import ExpandableText from '@alltrails/denali/components/ExpandableText';
import styles from './Description.module.scss';

type Props = {
  children?: React.ReactNode;
  descriptionText: string;
  pageType?: PageType;
  sanitizedInnerHtml?: string;
};

const ExpandableDescription = ({ children, descriptionText, pageType, sanitizedInnerHtml }: Props) => {
  return (
    <div className={styles.locationDescriptionContainer}>
      <ExpandableText
        className={styles.locationDescription}
        maxLines={3}
        onClick={() => {
          if (pageType) {
            logShowMoreClicked({ page_type: pageType, show_more_location: 'overview' });
          }
        }}
        sanitizedInnerHtml={sanitizedInnerHtml}
        text={descriptionText}
        scrollMarginTop={70} // 64px is the height of the sticky header, leaving extra margin
      >
        {children}
      </ExpandableText>
    </div>
  );
};

export default ExpandableDescription;
